import { TEMPLATE_BLUR } from './templateBlur.generated';

const SPACES = 'https://genres.nyc3.cdn.digitaloceanspaces.com';

// New template media (built by scripts/build_media.py, uploaded by scripts/upload_media.py).
export const MEDIA_BASE = process.env.REACT_APP_MEDIA_BASE || `${SPACES}/xyz`;

// The 12 live templates reuse the clips fuckable serves today.
const LIVE_BASE = { p0rn: `${SPACES}/p0rn`, legacy: `${SPACES}/thumbnails/video_gen/videos` };
const LIVE_SOURCE_PHOTOS = `${SPACES}/makeporn`;

export const PAGE_SIZE = 12;
// Every page of the unfiltered view is a bento led by a 2x2 featured scene. To stay a clean rectangle at
// 4, 3 and 2 columns, page 1 holds 11 scenes (featured + 2x1 slot + 10) and the others 9 (featured + 8).
export const BENTO_FIRST_PAGE = 11;
export const BENTO_PAGE = 9;
// Sample image the backend animates when the user has no photo of their own
// (…/video_gen/images/{action}{SAMPLE_IDX}.png on the backend side).
export const SAMPLE_IDX = 200;

export const TAGS = [
    { key: 'all', label: 'All' },
    { key: 'live', label: 'Available now', paidOnly: true },
    { key: 'oral', label: 'Oral' },
    { key: 'sex', label: 'Sex' },
    { key: 'pov', label: 'POV' },
    { key: 'solo', label: 'Solo & Tease' },
    { key: 'feet', label: 'Feet' },
    { key: 'group', label: 'Group' },
];

// Coming soon: preview only. `fallback` is the closest template that already generates.
// Visitors without an active subscription never see the soon/live split (see `paid` in the UI).
const soon = (id, title, tags, fallback, badge) => ({
    id, title, tags, fallback, badge, status: 'soon', aspect: '3 / 4', audio: true,
});

// Live: `action` is the backend pipeline key sent to POST /gen/animate.
const live = (action, title, file, tags, extra = {}) => ({
    id: action, action, title, file, tags, status: 'live', aspect: '3 / 4', audio: false, cdn: 'p0rn', ...extra,
});

// Order is editorial: five hand-picked openers, the rest of the new scenes mixed by theme,
// then the 12 live scenes last. Badges are sparse on purpose: two HOT, two NEW.
export const VIDEO_TEMPLATES = [
    soon('undress', 'Undress', ['solo'], 'posing'),
    soon('surrounded', 'Surrounded', ['group'], 'cumshot', 'HOT'),
    soon('show-ass', 'Show Ass', ['solo'], 'twerking'),
    soon('sixty-nine-long', '69', ['oral'], 'blowjob', 'NEW'),
    soon('car-blowjob', 'Car Blowjob', ['oral'], 'blowjob'),

    soon('pov-doggy', 'POV Doggy', ['pov', 'sex'], 'pov_insertion'),
    soon('robe-reveal', 'Robe Reveal', ['solo'], 'posing'),
    soon('plane-blowjob', 'Mile-High Blowjob', ['oral'], 'blowjob', 'HOT'),
    soon('cowgirl-back-view', 'Cowgirl · Back View', ['sex'], 'reverse_cowgirl'),
    soon('footjob', 'Footjob', ['feet'], 'show_feet'),
    soon('messy-blowjob', 'Messy Blowjob', ['oral', 'pov'], 'cumshot'),
    soon('classic-sex', 'Classic Sex', ['sex'], 'pov_insertion'),
    soon('dildo-play', 'Dildo Play', ['solo'], 'fingering'),
    soon('two-guy-blowjob', 'Two-Guy Blowjob', ['oral', 'group'], 'blowjob'),
    soon('standing-sex', 'Standing Sex', ['sex'], 'full_nelson'),
    soon('solo-fingering', 'Solo Fingering', ['solo'], 'fingering'),
    soon('pov-titfuck', 'POV Titfuck', ['pov'], 'titfuck', 'NEW'),
    soon('rough-doggy', 'Rough Doggy', ['sex'], 'pov_insertion'),
    soon('feet-kiss', 'Feet Worship', ['feet'], 'show_feet'),
    soon('after-cum-kiss', 'After-Cum Kiss', ['pov', 'oral'], 'cumshot'),
    soon('sofa-sex', 'Sofa Sex', ['sex'], 'pov_insertion'),
    soon('lazy-morning', 'Lazy Morning', ['solo'], 'posing'),
    soon('pov-double-blowjob', 'POV Double Blowjob', ['pov', 'oral', 'group'], 'blowjob'),
    soon('reverse-cowgirl-ride', 'Reverse Cowgirl Ride', ['sex'], 'reverse_cowgirl'),
    soon('facesitting', 'Facesitting', ['oral'], 'rimming'),
    soon('ass-kiss-and-fuck', 'Ass Kiss & Fuck', ['sex', 'oral'], 'rimming'),

    live('cumshot', 'Cumshot', 'cumshot', ['oral', 'pov']),
    live('blowjob', 'Blowjob', 'blowjob', ['oral', 'pov']),
    live('titfuck', 'Titfuck', 'titfuck', ['pov']),
    live('twerking', 'Twerking', 'twerking', ['solo']),
    live('reverse_cowgirl', 'Cowgirl', 'cowgirl', ['sex']),
    live('fingering', 'Fingering', 'fingering', ['solo']),
    live('pov_insertion', 'POV Insertion', 'pov_insertion', ['pov', 'sex']),
    live('rimming', 'Rimming', 'rimming', ['oral']),
    live('posing', 'Posing', 'posing', ['solo']),
    live('full_nelson', 'Full Nelson', 'full_nelson', ['sex'], { cdn: 'legacy' }),
    live('show_feet', 'Show Feet', 'show_feet', ['feet'], { cdn: 'legacy' }),
    live('fisting', 'Fisting', 'fisting', ['solo']),
].map((t, i) => ({ ...t, index: i + 1 }));

// Filter chips for this visitor: "Available now" only exists for paying users.
export const tagsFor = (paid) => TAGS.filter((t) => paid || !t.paidOnly);

export const LIVE_TEMPLATES = VIDEO_TEMPLATES.filter((t) => t.status === 'live');

export const templateById = (id) => VIDEO_TEMPLATES.find((t) => t.id === id) || null;

export function resolveMedia(t) {
    if (t.status === 'live') {
        const base = LIVE_BASE[t.cdn];
        const poster = `${base}/${t.file}_thumbnail.jpg`;
        const video = `${base}/${t.file}_small.mp4`;
        // `source` pairs with the clip in the preview popup; `sample` is the image the backend
        // really animates for sample_idx (byte-identical to …/video_gen/images/{action}200.png).
        return { preview: video, video, poster, source: poster, sample: `${LIVE_SOURCE_PHOTOS}/${t.action}.jpg`, blur: null };
    }
    return {
        preview: `${MEDIA_BASE}/${t.id}_preview.mp4`,
        video: `${MEDIA_BASE}/${t.id}.mp4`,
        poster: `${MEDIA_BASE}/${t.id}.jpg`,
        source: `${MEDIA_BASE}/${t.id}_src.jpg`,
        sample: null,
        blur: TEMPLATE_BLUR[t.id] || null,
    };
}

export function filterTemplates(tag) {
    if (!tag || tag === 'all') return VIDEO_TEMPLATES;
    if (tag === 'live') return LIVE_TEMPLATES;
    return VIDEO_TEMPLATES.filter((t) => t.tags.includes(tag));
}

export function paginate(list, page, { size = PAGE_SIZE, firstPageSize = size } = {}) {
    const total = list.length;
    const first = Math.min(firstPageSize, total);
    const pages = total <= first ? 1 : 1 + Math.ceil((total - first) / size);
    const current = Math.min(Math.max(1, Math.trunc(Number(page)) || 1), pages);
    const from = current === 1 ? 0 : first + (current - 2) * size;
    const to = Math.min(from + (current === 1 ? first : size), total);
    return { items: list.slice(from, to), page: current, pages, from: total ? from + 1 : 0, to, total };
}
